module.exports = __webpack_public_path__ + "img/ring_skip_0_1_0@3x.02b06168.png";